var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number"},[_c('span',{staticClass:"current"},[_vm._v(" "+_vm._s(_vm.index + 1)+" ")]),_c('span',{staticClass:"limit"},[_vm._v(" /"+_vm._s(_vm.$store.getters.sections.length)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }